module.exports = __webpack_public_path__ + "r-v3/img/ml_13_00.597a5c2c.jpg";